module.exports = __webpack_public_path__ + "img/InvTransaction.01998517.jpg";